import React, { useState } from 'react';

const ProcessSection = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const steps = [
    {
      id: 1,
      icon: '/images/icons/search.webp',
      title: 'ЗАЯВКА НА САЙТЕ',
      description: 'Оставляете заявку, мы связываемся в течение 30 минут',
      rotate: -6,
    },
    {
      id: 2,
      icon: '/images/icons/audience.webp',
      title: 'ZOOM ВСТРЕЧА',
      description: 'Знакомимся, обсуждаем ваш бизнес и цели',
      rotate: 5,
    },
    {
      id: 3,
      icon: '/images/icons/shield.webp',
      title: 'ДОГОВОР И ОПЛАТА',
      description: 'Подписываем договор с гарантиями результата',
      rotate: -4,
    },
    {
      id: 4,
      icon: '/images/icons/analytics.webp',
      title: 'ЮНИТ-ЭКОНОМИКА',
      description: 'Анализируем цифры и строим финансовую модель',
      rotate: 6,
    },
    {
      id: 5,
      icon: '/images/icons/chart.webp',
      title: 'СОГЛАСУЕМ ПЛАНЫ',
      description: 'Утверждаем KPI и план действий на месяц',
      rotate: -5,
    },
    {
      id: 6,
      icon: '/images/icons/funnel.webp',
      title: 'ПРОСЧЁТ ВОРОНОК',
      description: 'Рассчитываем воронки продаж по каждому артикулу',
      rotate: 4,
    },
    {
      id: 7,
      icon: '/images/icons/conversion.webp',
      title: 'ВНЕСЕНИЕ ИЗМЕНЕНИЙ',
      description: 'Оптимизируем карточки, контент, инфографику',
      rotate: -6,
    },
    {
      id: 8,
      icon: '/images/icons/ads.webp',
      title: 'НАСТРОЙКА РЕКЛАМЫ',
      description: 'Запускаем и настраиваем рекламные кампании',
      rotate: 5,
    },
    {
      id: 9,
      icon: '/images/icons/rocket.webp',
      title: 'КОРРЕКЦИЯ ПЛАНОВ',
      description: 'Корректируем стратегию и достигаем планы',
      rotate: -4,
    },
    {
      id: 10,
      icon: '/images/icons/coins.webp',
      title: 'ПОЛУЧЕНИЕ ПРИБЫЛИ',
      description: 'Вы получаете стабильный рост и прибыль 🎉',
      rotate: 6,
    },
  ];

  return (
    <section
      className="process-section"
      style={{
        background: '#FFFFFF',
        padding: '100px 0 40px 0',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Декоративные круги и иконки */}
      <div
        className="process-decor"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          pointerEvents: 'none',
          zIndex: 1,
        }}
      >
        {/* Круг 1 - top-left */}
        <div
          style={{
            position: 'absolute',
            width: '400px',
            height: '400px',
            top: '-150px',
            left: '-150px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #22D3EE, #8B5CF6)',
            filter: 'blur(100px)',
            opacity: 0.1,
          }}
        />

        {/* Декоративные иконки на фоне с анимацией */}
        <img
                loading="lazy"
          src="/images/icons/rocket.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '90px',
            height: '90px',
            top: '8%',
            left: '6%',
            transform: 'rotate(-12deg)',
            opacity: 0.06,
            filter: 'blur(2px)',
            animation: 'floatProcess1 6s ease-in-out infinite',
          }}
        />
        <img
                loading="lazy"
          src="/images/icons/analytics.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '85px',
            height: '85px',
            top: '12%',
            right: '7%',
            transform: 'rotate(10deg)',
            opacity: 0.06,
            filter: 'blur(2px)',
            animation: 'floatProcess2 7s ease-in-out infinite',
          }}
        />
        <img
                loading="lazy"
          src="/images/icons/chart.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '95px',
            height: '95px',
            bottom: '15%',
            left: '5%',
            transform: 'rotate(15deg)',
            opacity: 0.06,
            filter: 'blur(2px)',
            animation: 'floatProcess3 5.5s ease-in-out infinite',
          }}
        />
        <img
                loading="lazy"
          src="/images/icons/funnel.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '80px',
            height: '80px',
            bottom: '18%',
            right: '8%',
            transform: 'rotate(-8deg)',
            opacity: 0.06,
            filter: 'blur(2px)',
            animation: 'floatProcess4 6.5s ease-in-out infinite',
          }}
        />
      </div>

      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 24px',
          position: 'relative',
          zIndex: 2,
        }}
      >
        {/* Заголовок */}
        <div
          className="process-header"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '24px',
            marginBottom: '60px',
            flexWrap: 'wrap',
          }}
        >
          <span
            style={{
              background: 'rgba(15, 15, 26, 0.08)',
              color: '#0F0F1A',
              fontSize: '14px',
              fontWeight: 500,
              padding: '12px 24px',
              borderRadius: '50px',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
            }}
          >
            ПРОЦЕСС
          </span>

          <h2
            className="process-title"
            style={{
              fontSize: '42px',
              fontWeight: 800,
              color: '#0F0F1A',
              textTransform: 'uppercase',
              lineHeight: 1.1,
              margin: 0,
            }}
          >
            КАК МЫ РАБОТАЕМ
          </h2>
        </div>

        {/* Сетка карточек этапов */}
        <div
          className="process-grid"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(5, 1fr)',
            gap: '20px',
            marginBottom: '60px',
            position: 'relative',
          }}
        >
          {/* Изогнутая линия соединяющая этапы */}
          <svg
            className="process-line"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              pointerEvents: 'none',
              zIndex: 0,
            }}
            viewBox="0 0 1000 500"
            preserveAspectRatio="none"
            fill="none"
          >
            <defs>
              <linearGradient id="processLineGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#22D3EE" stopOpacity="0.3" />
                <stop offset="50%" stopColor="#8B5CF6" stopOpacity="0.3" />
                <stop offset="100%" stopColor="#EC4899" stopOpacity="0.3" />
              </linearGradient>
            </defs>
            {/* Ряд 1: этапы 1→5, волна через верхний ряд */}
            <path
              d="M 90 120 Q 150 60, 290 120 Q 430 180, 500 120 Q 570 60, 710 120 Q 850 180, 910 120"
              stroke="url(#processLineGrad)"
              strokeWidth="3"
              strokeDasharray="12 8"
              strokeLinecap="round"
            />
            {/* Переход между рядами: 5→6 */}
            <path
              d="M 910 120 C 960 200, 40 300, 90 380"
              stroke="url(#processLineGrad)"
              strokeWidth="3"
              strokeDasharray="12 8"
              strokeLinecap="round"
            />
            {/* Ряд 2: этапы 6→10, волна через нижний ряд */}
            <path
              d="M 90 380 Q 150 320, 290 380 Q 430 440, 500 380 Q 570 320, 710 380 Q 850 440, 910 380"
              stroke="url(#processLineGrad)"
              strokeWidth="3"
              strokeDasharray="12 8"
              strokeLinecap="round"
            />
          </svg>

          {steps.map((step, index) => (
            <div
              key={step.id}
              style={{
                position: 'relative',
                marginTop: '10px',
              }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              {/* Glow border при hover */}
              <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  borderRadius: '20px',
                  background: 'linear-gradient(135deg, #22D3EE 0%, #8B5CF6 35%, #EC4899 65%, #FBBF24 100%)',
                  filter: 'blur(12px)',
                  opacity: hoveredIndex === index ? 0.2 : 0,
                  transition: 'opacity 0.3s ease',
                  zIndex: -1,
                }}
              />

              {/* Карточка */}
              <div
                className="process-card"
                style={{
                  background: index === steps.length - 1
                    ? 'linear-gradient(135deg, rgba(34, 211, 238, 0.08), rgba(236, 72, 153, 0.08))'
                    : '#F8F9FA',
                  border: hoveredIndex === index
                    ? '1px solid rgba(34, 211, 238, 0.3)'
                    : '1px solid rgba(139, 92, 246, 0.1)',
                  borderRadius: '20px',
                  padding: '24px',
                  minHeight: '180px',
                  position: 'relative',
                  overflow: 'visible',
                  transition: 'all 0.3s ease',
                  transform: hoveredIndex === index ? 'translateY(-4px)' : 'translateY(0)',
                  boxShadow:
                    hoveredIndex === index
                      ? '0 8px 32px rgba(139, 92, 246, 0.25), 0 0 60px rgba(236, 72, 153, 0.15)'
                      : '0 4px 20px rgba(139, 92, 246, 0.08), 0 0 30px rgba(236, 72, 153, 0.04)',
                }}
              >
                {/* Номер этапа - водяной знак */}
                <div
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '20px',
                    transform: 'translateY(-50%)',
                    fontSize: '100px',
                    fontWeight: 900,
                    color: '#0F0F1A',
                    opacity: 0.04,
                    lineHeight: 1,
                    pointerEvents: 'none',
                    userSelect: 'none',
                    zIndex: 0,
                  }}
                >
                  {step.id}
                </div>

                {/* Контент */}
                <div
                  style={{
                    paddingRight: '60px',
                    position: 'relative',
                    zIndex: 1,
                  }}
                >
                  <h3
                    style={{
                      fontSize: '15px',
                      fontWeight: 700,
                      color: '#0F0F1A',
                      textTransform: 'uppercase',
                      margin: '0 0 10px 0',
                      lineHeight: 1.3,
                    }}
                  >
                    {step.title}
                  </h3>
                  <p
                    style={{
                      fontSize: '13px',
                      fontWeight: 400,
                      color: 'rgba(15, 15, 26, 0.6)',
                      lineHeight: 1.5,
                      margin: 0,
                    }}
                  >
                    {step.description}
                  </p>
                </div>

                {/* Иконка с glow эффектом */}
                <div
                  className="process-icon-wrap"
                  style={{
                    position: 'absolute',
                    bottom: '-30px',
                    right: '-15px',
                    zIndex: 10,
                  }}
                >
                  {/* Glow эффект */}
                  <div
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      width: '187px',
                      height: '187px',
                      background: 'radial-gradient(circle, rgba(249, 115, 22, 0.3) 0%, rgba(236, 72, 153, 0.2) 40%, transparent 70%)',
                      filter: 'blur(12px)',
                      zIndex: -1,
                      pointerEvents: 'none',
                      opacity: hoveredIndex === index ? 0.9 : 0.5,
                      transition: 'opacity 0.3s ease',
                    }}
                  />

                  <img
                loading="lazy"
                    src={step.icon}
                    alt=""
                    style={{
                      width: '121px',
                      height: '121px',
                      objectFit: 'contain',
                      position: 'relative',
                      zIndex: 1,
                      opacity: hoveredIndex === index ? 1 : 0.7,
                      transform: hoveredIndex === index ? 'rotate(8deg) scale(1.15)' : `rotate(${step.rotate}deg)`,
                      transition: 'all 0.4s ease',
                    }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA кнопка */}
        <div
          style={{
            textAlign: 'center',
          }}
        >
          <button
            style={{
              background: 'linear-gradient(135deg, #F97316 0%, #EC4899 100%)',
              border: 'none',
              color: '#FFFFFF',
              fontSize: '16px',
              fontWeight: 600,
              textTransform: 'uppercase',
              padding: '20px 48px',
              borderRadius: '50px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
            }}
            onClick={() => window.dispatchEvent(new Event('openModal'))}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 12px 40px rgba(249, 115, 22, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            НАЧАТЬ РАБОТУ →
          </button>
        </div>
      </div>

      {/* Анимации и стили */}
      <style>
        {`
          /* Анимации плавающих иконок на фоне */
          @keyframes floatProcess1 {
            0%, 100% { transform: translate(0, 0) rotate(-12deg); }
            50% { transform: translate(-10px, -15px) rotate(-12deg); }
          }

          @keyframes floatProcess2 {
            0%, 100% { transform: translate(0, 0) rotate(10deg); }
            50% { transform: translate(10px, -20px) rotate(10deg); }
          }

          @keyframes floatProcess3 {
            0%, 100% { transform: translate(0, 0) rotate(15deg); }
            50% { transform: translate(-15px, -10px) rotate(15deg); }
          }

          @keyframes floatProcess4 {
            0%, 100% { transform: translate(0, 0) rotate(-8deg); }
            50% { transform: translate(15px, -15px) rotate(-8deg); }
          }

          /* Тонкая анимация для всех иконок карточек */
          @keyframes iconFloat {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-5px); }
          }

          @media (max-width: 1200px) {
            .process-grid {
              grid-template-columns: repeat(4, 1fr) !important;
            }
          }

          @media (max-width: 1024px) {
            .process-grid {
              grid-template-columns: repeat(3, 1fr) !important;
            }
          }

          @media (max-width: 768px) {
            .process-section { padding: 50px 0 30px 0 !important; }
            .process-header { flex-direction: column !important; align-items: flex-start !important; gap: 12px !important; margin-bottom: 40px !important; }
            .process-title { font-size: 28px !important; }
            .process-decor { display: none !important; }
            .process-grid {
              grid-template-columns: repeat(2, 1fr) !important;
              gap: 24px 16px !important;
            }
            .process-line { display: none !important; }
            .process-card { min-height: auto !important; padding: 16px !important; border-radius: 16px !important; }
            .process-card > div:first-child { font-size: 60px !important; }
            .process-icon-wrap { bottom: -15px !important; right: -8px !important; }
            .process-icon-wrap img { width: 70px !important; height: 70px !important; }
            .process-icon-wrap > div:first-child { width: 100px !important; height: 100px !important; }
          }

          @media (max-width: 480px) {
            .process-section { padding: 40px 0 20px 0 !important; }
            .process-title { font-size: 24px !important; }
            .process-grid {
              grid-template-columns: 1fr !important;
              gap: 24px !important;
            }
            .process-card { padding: 14px !important; }
            .process-icon-wrap img { width: 60px !important; height: 60px !important; }
            .process-icon-wrap { bottom: -12px !important; right: -5px !important; }
          }
        `}
      </style>
    </section>
  );
};

export default ProcessSection;
